(function (ng, app) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider
                .state("Home.Tools.MarketingTrackerNew.Contacts.ContactView.BusinessView",
                    {
                        url: "/BusinessView",
                        component: "businessView",
                        PageTitle: "Contact Business | Marketing Tracker"
                    });
        }
    ]);


    app
        .component("businessView",
            {
                templateUrl: "App/Tools/MarketingTrackerNew/Contacts/ContactView/BusinessView/business-view-template.html",
                controller: businessViewController,
                bindings: {
                    contactId: "<",
                    contactEmail: "<"
                }
            });

    businessViewController.$inject = [
        "marketingTrackerContactApi",
        "figToaster",
        "marketingTrackerAgentApi"
    ];
    function businessViewController(
        marketingTrackerContactApi,
        figToaster,
        marketingTrackerAgentApi
    ) {
        const $ctrl = this;

        ng.extend($ctrl,
            {
                ui: {
                    loading: false
                },
                pageSizes: [25, 50, 100],
                policiesList: [],
                toggleSort: toggleSort
            });

        function toggleSort(propertyName) {
            $ctrl.reverseOrder = $ctrl.propertyName === propertyName ? !$ctrl.reverseOrder : false;
            $ctrl.propertyName = propertyName;
        }

        function _getContact(contactId) {
            $ctrl.ui.loadingData = true;
            marketingTrackerContactApi.getContactById(contactId)
                .then(function (response) {
                    $ctrl.contact = response;
                })
                .then(_getContactPolicies)
                .catch(function (error) {
                    console.log("Error: " + error.data);
                    message = "There was a problem retrieving your data. Please try again shortly.";
                    toastClass = "is-error";
                    figToaster.showSimple(message, "top", toastClass);
                })
                .finally(function () {
                    $ctrl.ui.contactUpdates = ng.copy($ctrl.contact);
                    $ctrl.ui.loadingData = false;
                });
        }
        function _getContactPolicies() {
            $ctrl.loading = true;
            marketingTrackerAgentApi.getContactPoliciesByEmail($ctrl.contactEmail)
                .then(function (response) {
                    $ctrl.policiesList = response;
                })
                .catch(function (error) {
                    console.log('Error getting policies list', error);
                    toastMessage = "There was a problem loading policies. Please try again shortly.";
                    toastClass = "is-error";
                    figToaster.showSimple(toastMessage, "top", toastClass);
                })
                .finally(function () {
                    _resetFilters();
                    $ctrl.ui.loading = false;
                });
        }

        function _resetFilters(propertyName, pageSize, reverseOrder, currentPage, contactSearch) {
            $ctrl.propertyName = propertyName || 'Carrier';
            $ctrl.pageSize = pageSize || $ctrl.pageSizes[0];
            $ctrl.reverseOrder = reverseOrder || false;
            $ctrl.currentPage = currentPage || 1;
        }


        $ctrl.$onInit = function () {
            _getContact($ctrl.contactId);
        };
    }

})(window.angular, window.app); //jshint ignore:line